export const getDefaultState = () => {
  return {
    demo: null,
    data: {
      bs_app_02_008: null,
      info_detail: null
    },
    bs_app: {
      bs_app_02_008: null,
      bs_app_02_001: null,
      bs_app_02_002: null,
      bs_app_02_005: null,
      bs_app_02_004: null,
      info_detail: null,
      bs_app_03_001: null,
      bs_app_03_002: null,
      selected_web_radio: null,
      check_relationship: null,
      public_stay: null,
      info_user: null
    }
  }
}

export const initState = () => {
  const bs_app = JSON.parse(sessionStorage.getItem('bs_app'))
  if(bs_app){
    sessionStorage.removeItem('bs_app')
    return bs_app
  }
  else{
    return getDefaultState()
  }
}

const state = initState()
export default state
